import { Typography, useTheme } from "@mui/material";
import { answerColorToThemeColor } from "components/Evaluation/Utils";
import { AnswerColor } from "components/UI/AcxAnswerSelector";
import React from "react";

type ResultBadgeProps = React.PropsWithChildren<{
    color?: AnswerColor;
}>;

export function ResultBadge(props: ResultBadgeProps) {
    const theme = useTheme();
    const colors = answerColorToThemeColor(theme, props.color);

    return (
        <Typography
            component="span"
            sx={(theme) => ({
                color: theme.palette.gray[700],
                backgroundColor: colors.backgroundColor,
                width: "fit-content",
                paddingInline: theme.spacing(1),
                paddingBlock: theme.spacing(0.5),
                borderRadius: theme.shape.borderRadius / 4,
                fontWeight: 600,
                lineHeight: "20px",
                fontSize: "12px",
            })}
        >
            {props.children}
        </Typography>
    );
}
